import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpService} from '../../../../../core';
import {MatDialog} from '@angular/material/dialog';
import {EditPackagePropertyDialogComponent} from '../../packages/property-package/edit-package-property-dialog/edit-package-property-dialog.component';


@Component({
    selector: 'app-manage-property',
    templateUrl: './manage-property.component.html',
    styleUrls: ['./manage-property.component.scss']
})

export class ManagePropertyComponent implements OnInit {

    @Input() project: any;
    @Input() isPackageProperty: boolean;
    dataSourceForMatrix = [];
    page: any;
    pageSize: any;
    // @Input() properties: any;

    @Output() signalClosingDialog = new EventEmitter();

    // displayedColumns = ['id', 'action'];
    constructor(private router: Router,
                private route: ActivatedRoute,
                private dialog: MatDialog,
                private httpService: HttpService) {
    }

    ngOnInit(): void {
        console.log(this.project);
        const temp = JSON.parse(JSON.stringify(this.project.properties));
        const levelSet = new Set();
        temp.forEach((property) => {
            levelSet.add(property.level);
        });

        levelSet.forEach((level) => {
            this.dataSourceForMatrix.push({
                level,
                properties: this.project.properties.filter(property => property.level === level).sort(this.compareUnit)
            });
        });
        this.dataSourceForMatrix.sort(this.compareFloor);
        // this.httpService.getAllPropertiesByProjectId(this.project.id).subscribe((res: any) => {
        //   console.log(res);
        // });
    }

    compareFloor(a, b) {
        const levelA = a.level;
        const levelB = b.level;
        let comparison = 0;
        if (levelA < levelB) {
            comparison = 1;
        } else if (levelA > levelB) {
            comparison = -1;
        }
        return comparison;
    }

    compareUnit(a, b) {
        const unitA = a.unit;
        const unitB = b.unit;
        let comparison = 0;
        if (unitA > unitB) {
            comparison = 1;
        } else if (unitA < unitB) {
            comparison = -1;
        }
        return comparison;
    }

    editProperty(property) {
        if (this.isPackageProperty) {
            // if editing a package's property, then open the dialog for editing package's property
            this.dialog.open(EditPackagePropertyDialogComponent, {
                width: '95%',
                maxWidth: '1400px',
                data: {
                    project: this.project,
                    property
                }
            });
            this.signalClosingDialog.emit({value: true});
        } else {
            this.router.navigate(
                ['/projects/' + this.project.id + '/edit/' + property.id],
                {
                    queryParams: {projectCode: this.project.projectCode, projectName: this.project.name},
                    state: {project: this.project}
                }
            ).then();
        }

    }

    transformLevel(level) {
        switch (level) {
            case -1:
                return 'GC';
            case -2:
                return 'GB';
            case -3:
                return 'GA';
            case -4:
                return 'G';
            case -5:
                return 'LG';
            case -6:
                return 'L';
            case -7:
                return 'B';
            case -8:
                return 'B1';
            case -9:
                return 'B2';
            case -10:
                return 'B3';
            case -11:
                return 'B4';
            case -12:
                return 'B5';
            default:
                return level;
        }
    }
}
